import Vue from 'vue';

const deliveryNotificationMessagesRepository = {
  list: () => Vue.$axios.get(`delivery-notification-messages/all`)
  .then(({data}) => data),

  get: (id) => Vue.$axios.get(`delivery-notification-messages/get/${id}`)
  .then(({data}) => data),

  update: (id, text, enabled, customerCategoriesWithoutNotifications) => {
    let data = new FormData();
    data.append('id', id);
    data.append('text', text);
    data.append('enabled', enabled);
    data.append('customerCategoriesWithoutNotifications', customerCategoriesWithoutNotifications);

    return Vue.$axios.post(`delivery-notification-messages/update`, data)
    .then(({data}) => data);
  },

  enable: (id) => {
    let data = new FormData();
    data.append('id', id);

    return Vue.$axios.post(`delivery-notification-messages/enable`, data)
    .then(({data}) => data);
  },

  disable: (id) => {
    let data = new FormData();
    data.append('id', id);

    return Vue.$axios.post(`delivery-notification-messages/disable`, data)
    .then(({data}) => data);
  },

  sendTestMessage: (phone, text, testSum, testNumber, testClient, testAddress) => {
    let data = new FormData();
    data.append('phone', phone);
    data.append('text', text);
    data.append('testSum', testSum);
    data.append('testNumber', testNumber);
    data.append('testClient', testClient);
    data.append('testAddress', testAddress);

    return Vue.$axios.post(`delivery-notification-messages/send-test-message`, data)
    .then(({data}) => data);
  },
};

export default deliveryNotificationMessagesRepository;
